(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primal-editorial-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (root) => {
    if (root.dataset.prReady) return;
    root.dataset.prReady = 'true';
    const track = root.querySelector('[data-pr-gallery-track]');
    const nav = root.querySelector('[data-pr-gallery-nav]');
    if (!track || !nav) return;
    const [prev, next] = nav.querySelectorAll('[data-pr-gallery-step]');

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    };

    nav.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-pr-gallery-step]');
      if (!button) return;
      const step = Number(button.dataset.prGalleryStep) * track.clientWidth * 0.8;
      track.scrollBy({ left: step, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };

  const init = () => document.querySelectorAll('[data-pr-gallery]').forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primal-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => { const button = event.target.closest('[data-primal-photo]'); if (!button) return; const card = button.closest('.ph-product'); const image = card?.querySelector('.ph-product-image img'); if (!image) return; image.src = button.dataset.primalPhoto; image.removeAttribute('srcset'); image.alt = button.dataset.photoAlt; card.querySelectorAll('[data-primal-photo]').forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false')); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primal-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const applyFilter = (root, value) => {
    let shown = 0;
    root.querySelectorAll('[data-pr-chip]').forEach((chip) => {
      chip.setAttribute('aria-pressed', String(chip.dataset.prChip === value));
    });
    root.querySelectorAll('.pr-products__item[data-category]').forEach((item) => {
      const match = value === 'all' || item.dataset.category === value;
      item.hidden = !match;
      if (match) shown += 1;
    });
    const status = root.querySelector('[data-pr-status]');
    if (status) {
      status.textContent =
        shown === 1 ? status.dataset.templateOne || '' : (status.dataset.template || '').replace('__n__', String(shown));
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const chip = event.target.closest('[data-pr-chip]');
    if (chip) {
      const root = chip.closest('[data-pr-products]');
      if (root) applyFilter(root, chip.dataset.prChip);
      return;
    }

    const trigger = event.target.closest('[data-pr-filter]');
    if (!trigger) return;
    const root = document.querySelector('[data-pr-products]');
    if (!root) return;
    event.preventDefault();
    const value = trigger.dataset.prFilter;
    const hasMatch = root.querySelector(`.pr-products__item[data-category="${CSS.escape(value)}"]`);
    applyFilter(root, hasMatch ? value : 'all');
    root.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
